import { Repository } from "src/firebase/firestore/repository";
import { ActiveSlotsReport } from "../types/slot.entity";

class ActiveSlotsReportsRepository extends Repository<ActiveSlotsReport> {
  constructor() {
    super("active_slots_reports");
  }
}

export const activeSlotsReportsRepository = new ActiveSlotsReportsRepository();
